import { useTranslation } from 'react-i18next'

import Button from 'src/core/components/Button'
import { clearChunkReloadFlag } from 'src/core/utils/lazyWithRetry'

const RouteErrorBoundary = () => {
	const { t } = useTranslation()

	const refresh = () => {
		clearChunkReloadFlag()
		window.location.reload()
	}

	return (
		<div className="flex h-screen w-screen flex-col items-center justify-center gap-8 overflow-hidden px-6">
			<div className="flex flex-col items-center justify-center gap-4">
				<h1>{t('Something went wrong')}</h1>
				<p className="text-center">
					{t('A new version of Cavell may be available. Refresh the page to continue.')}
				</p>
			</div>
			<Button onClick={refresh}>{t('Refresh')}</Button>
		</div>
	)
}

export default RouteErrorBoundary
